import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import Chart from "react-apexcharts";
import { Spin } from "antd";
import HelpLabel from "../../../components/HelpLabel";
const EARLY_COLOR = '#03a9f4';
const ON_TIME_COLOR = '#4caf50';
const LATE_COLOR = '#ff9800';
const DIFOTWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateSeries, setStateSeries] = useState();
    const [stateCompletedPunctualPercent, setStateCompletedPunctualPercent] = useState(null);
    const [stateDIFOT, setStateDIFOT] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadDIFOT();
    };
    const loadDIFOT = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/difot/${props.date}`)
            .then(response => {
            const difot = response.data;
            const series = [{
                    name: 'Early',
                    data: [difot.completedEarly]
                }, {
                    name: 'On Time',
                    data: [difot.completedOnTime]
                }, {
                    name: 'Late',
                    data: [difot.completedLate]
                }];
            const completedPunctualPercent = (!difot.completedTotal) ? 0
                : Math.round((difot.completedEarly + difot.completedOnTime) / difot.completedTotal * 100);
            setStateSeries(series);
            setStateCompletedPunctualPercent(completedPunctualPercent);
            setStateDIFOT(difot);
        }).catch(error => {
            setStateSeries([]);
            setStateCompletedPunctualPercent(null);
            setStateDIFOT(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("h2", { children: "DIFOT" }), (!stateLoading && stateSeries) &&
                    _jsxs("div", { className: "widget-bar-chart", children: [_jsx(Chart, { options: {
                                    chart: {
                                        type: 'bar',
                                        stacked: true,
                                        stackType: '100%',
                                        toolbar: {
                                            show: false,
                                        },
                                        sparkline: {
                                            enabled: true
                                        }
                                    },
                                    dataLabels: {
                                        enabled: true
                                    },
                                    colors: [EARLY_COLOR, ON_TIME_COLOR, LATE_COLOR],
                                    plotOptions: {
                                        bar: {
                                            horizontal: true
                                        },
                                    },
                                    xaxis: {
                                        categories: ['DIFOT'] // For Tooltip
                                    }
                                }, series: stateSeries, type: "bar", height: 40, width: '100%' }), _jsxs("p", { className: "widget-chart-legend", children: [_jsx("span", { style: { color: EARLY_COLOR }, children: stateDIFOT?.completedEarly }), " Early\u00A0 \u00A0", _jsx("span", { style: { color: ON_TIME_COLOR }, children: stateDIFOT?.completedOnTime }), " On Time\u00A0 \u00A0", _jsx("span", { style: { color: LATE_COLOR }, children: stateDIFOT?.completedLate }), " Late\u00A0 \u00A0", _jsx("span", { children: stateDIFOT?.completedTotal }), " Total\u00A0 \u00A0", _jsxs("span", { children: [stateCompletedPunctualPercent, "%"] }), " Punctual", _jsx(HelpLabel, { title: "", helpText: _jsx("p", { children: "This Delivery In Full On Time (DIFOT) is calculated using the time the driver completed the delivery and comparing this to the time the customer requested the delivery. If the driver completed the delivery early, on time or late is depicted as a percentage of the total in the chart." }) })] })] })] }) }));
};
export default React.forwardRef(DIFOTWidget);
